var _rect, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup33626(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 76,
    viewBox: "0 0 241 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.344788,
    width: 240.104,
    height: 75.7549,
    rx: 33.5294,
    fill: "#001F52"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7489 30.6082L32.3431 19.3634C32.0993 19.2199 31.7925 19.2278 31.5565 19.3714C31.3126 19.5149 31.1632 19.7701 31.1632 20.0572C31.1632 20.0572 31.1711 21.094 31.1789 22.8006L45.3144 37.1318L51.7489 30.6082Z",
    fill: "url(#paint0_linear_12_316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1788 22.8007C31.2024 28.9574 31.2732 43.9026 31.3047 51.3434L45.3222 37.1318L31.1788 22.8007Z",
    fill: "url(#paint1_linear_12_316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8559 37.044L51.7489 30.6082L45.3065 37.1318L52.5748 44.5007L62.8638 38.4237C63.1076 38.2802 63.2571 38.017 63.2571 37.7379C63.2571 37.4508 63.0997 37.1876 62.8559 37.044Z",
    fill: "url(#paint2_linear_12_316)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2968 51.3433C31.3126 53.999 31.3204 55.6977 31.3204 55.6977C31.3204 55.9848 31.4699 56.248 31.7138 56.3836C31.9576 56.5271 32.2565 56.5271 32.5004 56.3836L52.5827 44.5087L45.3144 37.1398L31.2968 51.3433Z",
    fill: "url(#paint3_linear_12_316)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.1063 39.6666H89.8214C89.2933 42.0606 87.2866 43.7388 84.5874 43.7388C81.5363 43.7388 79.2362 41.2861 79.2362 38.1058C79.2362 35.0077 81.5011 32.5668 84.6109 32.5668C86.7233 32.5668 88.5188 33.7051 89.352 35.4419L91.9807 34.4092C90.7015 31.7453 88.0024 30.0202 84.6579 30.0202C79.9872 30.0202 76.3845 33.5408 76.3845 38.0706C76.3845 42.6474 79.8464 46.1445 84.341 46.1445C87.0166 46.1445 89.1994 44.8888 90.3377 42.976L90.7719 45.8277H92.3679V37.3783H84.1063V39.6666ZM100.792 46.1445C104.312 46.1445 107.176 43.5041 107.176 39.9483C107.176 36.3808 104.371 33.799 100.839 33.799C97.2713 33.799 94.4431 36.4277 94.4431 39.9952C94.4431 43.551 97.2243 46.1445 100.792 46.1445ZM100.815 43.7036C98.7499 43.7036 97.1774 42.1311 97.1774 39.9718C97.1774 37.8125 98.7499 36.2282 100.815 36.2282C102.834 36.2282 104.442 37.8125 104.442 39.9718C104.442 42.1311 102.834 43.7036 100.815 43.7036ZM114.888 46.1445C118.409 46.1445 121.272 43.5041 121.272 39.9483C121.272 36.3808 118.467 33.799 114.935 33.799C111.367 33.799 108.539 36.4277 108.539 39.9952C108.539 43.551 111.32 46.1445 114.888 46.1445ZM114.911 43.7036C112.846 43.7036 111.273 42.1311 111.273 39.9718C111.273 37.8125 112.846 36.2282 114.911 36.2282C116.93 36.2282 118.538 37.8125 118.538 39.9718C118.538 42.1311 116.93 43.7036 114.911 43.7036ZM132.716 35.7588C131.73 34.5266 130.263 33.8107 128.503 33.8107C125.241 33.8107 122.635 36.2869 122.635 39.7605C122.635 43.2224 125.194 45.7455 128.479 45.7103C130.205 45.6986 131.625 45.0062 132.61 43.8444V45.0414C132.61 47.0716 131.143 48.6089 129.054 48.6089C127.224 48.6089 126.121 47.7405 125.64 46.3792L123.058 47.189C123.832 49.3835 125.909 50.7213 128.996 50.7213C132.845 50.7213 135.368 48.2334 135.368 44.748V34.1041H133.021L132.716 35.7588ZM128.961 43.3985C126.966 43.3985 125.393 41.8377 125.393 39.7605C125.393 37.6951 126.966 36.1343 128.961 36.1343C130.967 36.1343 132.61 37.7068 132.61 39.7605C132.61 41.8259 130.967 43.3985 128.961 43.3985ZM141.182 45.8277V28.8936L138.424 29.1636V45.8277H141.182ZM156.075 40.0774C156.075 36.4864 153.458 33.799 149.774 33.799C146.241 33.799 143.401 36.3338 143.401 39.9952C143.401 43.5393 146.018 46.1445 149.797 46.1445C152.531 46.1445 154.62 44.8536 155.582 42.9056L153.212 41.9316C152.672 43.1403 151.334 43.9383 149.785 43.9266C147.767 43.9031 146.417 42.5066 146.183 40.8988H156.052C156.075 40.582 156.075 40.3708 156.075 40.0774ZM149.715 36.0052C151.475 36.0052 152.836 37.0849 153.177 38.7278H146.241C146.593 37.1553 147.99 36.0052 149.715 36.0052ZM162.697 30.3371V45.8277H165.466V40.6524H169.351C172.601 40.6524 174.937 38.5166 174.937 35.4889C174.937 32.4612 172.601 30.3371 169.351 30.3371H162.697ZM165.466 38.2819V32.7076H169.233C170.993 32.7076 172.132 33.8577 172.132 35.5006C172.132 37.1318 170.993 38.2819 169.233 38.2819H165.466ZM179.665 45.8277V28.8936L176.907 29.1636V45.8277H179.665ZM192.001 35.8409C191.015 34.5501 189.536 33.8107 187.776 33.8107C184.502 33.8107 181.885 36.3456 181.885 39.9718C181.885 43.6332 184.513 46.121 187.752 46.121C189.513 46.121 191.003 45.3817 191.989 44.0791L192.294 45.8277H194.653V34.1041H192.294L192.001 35.8409ZM188.21 43.7036C186.215 43.7036 184.643 42.1428 184.643 39.9718C184.643 37.789 186.215 36.2282 188.21 36.2282C190.229 36.2282 191.895 37.8125 191.895 39.9718C191.895 42.1311 190.229 43.7036 188.21 43.7036ZM205.7 34.1041V40.4294C205.7 42.2836 204.55 43.3515 202.954 43.3515C201.358 43.3515 200.419 42.4127 200.419 40.6524V34.1041H197.673V41.2861C197.673 43.997 199.468 45.7807 201.991 45.7807C203.552 45.7807 204.866 45.1588 205.7 44.1613V45.769C205.7 47.4471 204.479 48.6089 202.649 48.6089C201.111 48.6089 199.961 47.8109 199.656 46.3792L197.121 47.189C197.731 49.3952 199.82 50.7213 202.625 50.7213C206.193 50.7213 208.457 48.4564 208.457 45.37V34.1041H205.7Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_316",
    x1: 31.1632,
    y1: 28.1993,
    x2: 51.7526,
    y2: 28.1993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#5BBC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB96A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_316",
    x1: 31.1751,
    y1: 37.0754,
    x2: 45.314,
    y2: 37.0754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45AFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_316",
    x1: 45.314,
    y1: 37.5595,
    x2: 63.2552,
    y2: 37.5595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA51A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#FAB716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#FAC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC80F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_316",
    x1: 31.3003,
    y1: 46.8152,
    x2: 52.5824,
    y2: 46.8152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC3B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7515B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0995,
    height: 37.2354,
    fill: "white",
    transform: "translate(31.1603 19.2597)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup33626);
export default __webpack_public_path__ + "static/media/Group 33626.cc5e3f7512b610f62919e9aae3ec050a.svg";
export { ForwardRef as ReactComponent };